// SVG payment method logos (inline, no external deps)
export const VisaLogo = ({ className = "h-6" }) => (
  <svg viewBox="0 0 48 16" className={className} aria-label="Visa">
    <rect width="48" height="16" fill="#fff" />
    <text
      x="24"
      y="12"
      textAnchor="middle"
      fill="#1A1F71"
      fontFamily="Arial Black, sans-serif"
      fontSize="10"
      fontStyle="italic"
      fontWeight="900"
    >
      VISA
    </text>
  </svg>
);

export const MastercardLogo = ({ className = "h-6" }) => (
  <svg viewBox="0 0 48 30" className={className} aria-label="Mastercard">
    <rect width="48" height="30" fill="#fff" />
    <circle cx="20" cy="15" r="8" fill="#EB001B" />
    <circle cx="28" cy="15" r="8" fill="#F79E1B" />
    <path
      d="M24 9.2a7.9 7.9 0 010 11.6 7.9 7.9 0 010-11.6z"
      fill="#FF5F00"
    />
  </svg>
);

export const AmexLogo = ({ className = "h-6" }) => (
  <svg viewBox="0 0 48 16" className={className} aria-label="American Express">
    <rect width="48" height="16" fill="#016FD0" />
    <text
      x="24"
      y="11"
      textAnchor="middle"
      fill="#fff"
      fontFamily="Arial Black, sans-serif"
      fontSize="6"
      fontWeight="900"
    >
      AMEX
    </text>
  </svg>
);

export const PaypalLogo = ({ className = "h-6" }) => (
  <svg viewBox="0 0 60 16" className={className} aria-label="PayPal">
    <rect width="60" height="16" fill="#fff" />
    <text
      x="30"
      y="11"
      textAnchor="middle"
      fill="#003087"
      fontFamily="Arial Black, sans-serif"
      fontSize="8"
      fontWeight="900"
      fontStyle="italic"
    >
      Pay
    </text>
    <text
      x="42"
      y="11"
      fill="#009CDE"
      fontFamily="Arial Black, sans-serif"
      fontSize="8"
      fontWeight="900"
      fontStyle="italic"
    >
      Pal
    </text>
  </svg>
);

export const ApplePayLogo = ({ className = "h-6" }) => (
  <svg viewBox="0 0 60 24" className={className} aria-label="Apple Pay">
    <rect width="60" height="24" fill="#000" />
    <path
      d="M12 8.4c.5-.6.8-1.4.7-2.3-.7 0-1.6.5-2.1 1.1-.5.5-.9 1.4-.8 2.2.8.1 1.6-.4 2.2-1zM13 10.5c-1.2-.1-2.2.7-2.7.7-.6 0-1.4-.7-2.3-.6-1.2 0-2.3.7-2.9 1.8-1.2 2.2-.3 5.4.9 7.1.6.8 1.3 1.8 2.2 1.8.9 0 1.2-.6 2.3-.6s1.3.6 2.3.6 1.5-.9 2.1-1.7c.7-1 .9-1.9 1-2-.1 0-1.9-.7-1.9-2.9 0-1.8 1.5-2.7 1.6-2.7-.9-1.3-2.3-1.5-2.6-1.5zM24 8h-4v12h2v-4h2c2.2 0 3.7-1.5 3.7-4S26.2 8 24 8zm-.4 6H22V10h1.6c1.4 0 2.2.8 2.2 2s-.8 2-2.2 2zM32 12c-2 0-3.4 1.2-3.4 2.9h1.8c.1-.7.7-1.1 1.5-1.1s1.4.5 1.4 1.2v.5l-1.9.1c-1.8.1-2.8.9-2.8 2.2 0 1.4 1 2.3 2.5 2.3 1 0 1.9-.5 2.3-1.3h.1V20h1.8v-5c-.1-1.8-1.4-3-3.3-3zm-.5 6.6c-.7 0-1.2-.4-1.2-.9 0-.6.5-.9 1.3-1l1.6-.1v.5c0 .8-.8 1.5-1.7 1.5zM39 20l-1.6 4.5h-.1L35.7 20h-2l2.7 7.3-.1.4c-.2.7-.6 1-1.3 1-.1 0-.4 0-.5-.1v1.5c.1 0 .5.1.7.1 1.7 0 2.5-.7 3.2-2.7L41 20h-2z"
      fill="#fff"
    />
  </svg>
);
